<template>
  <div class="banner">
    <!-- 空格 -->
    <div class="kong"></div>
    <div class="container">
      <div class="ditu">
        <h2>公司地址</h2>
        <baidu-map class="map" :center="map.center" :zoom="map.zoom" @ready="handler">
          <!--缩放-->
          <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
          <!--定位-->
          <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true">
          </bm-geolocation>
          <!--点-->
          <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">
            <!--提示信息-->
            <bm-info-window :show="map.show">广西凭祥市综合保税区一期联检大楼7楼712室</bm-info-window>
          </bm-marker>
        </baidu-map>
      </div>
      <div class="r">
        <div class="r1">
          <span class="iconfont icon-fangzi"></span>
          <span class="ziti">公司地址</span>
          <span style="width: 580px;margin-left: 50px;">中国（广西）自由贸易试验区崇左片区凭祥市友谊关口岸（广西凭祥市综合保税区一期联检大楼）7楼712室</span>
        </div>
        <div class="r1">
          <span class="iconfont icon-dianhua01"></span>
          <span class="ziti">联系方式</span>
          <span style="width: 580px;margin-left: 50px;">0523-86958866</span>
        </div>
        <div class="r1">
          <span class="iconfont icon-icon35"></span>
          <span class="ziti">邮件咨询</span>
          <span style="width: 580px;margin-left: 50px;">ligongxiang@126.com</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "demo",
    data: () => ({
      map: {
        center: { lng:106.721179, lat:21.978192 },
        zoom: 15,
        show: true,
        dragging: true
      },
    }),
    methods: {
      handler({ BMap, map }) {
        let me = this;
        // console.log(BMap, map)
        // 鼠标缩放
        map.enableScrollWheelZoom(true);
        // 点击事件获取经纬度
        map.addEventListener('click', function (e) {
          console.log(e.point.lng, e.point.lat)
        })
      }
    },
  }
</script>
<style scoped>
  .icon-dianhua01:before {
    color: #F47310;
    font-size: 30px;
  }
  .icon-fangzi:before {
    color: #F47310;
  }
  .icon-icon35:before {
    color: #F47310;
  }
  .ziti {
    font-size: 20px;
    height: 50px;
    line-height: 50px;
    margin-left: 10px;
    font-weight: 500;
    color: #F47310;
  }

  .iconfont {
    font-size: 40px;
    height: 50px;
  }

  .r1>span {
    margin-top: 20px;
    display: block;
    float: left;
  }

  .r {
    float: right;
    width: 520px;
    height: 500px;
    margin-top: 100px;
  }

  .ditu {
    width: 600px;
    height: 550px;
    float: left;
    margin-top: 50px;
  }

  .map {
    width: 100%;
    height: 400px;
  }

  .kong {
    width: 100%;
    height: 125px;
  }

  .banner {
    background-image: none;
    background-color: #f8f8f8;
  }

  .container {
    width: 1200px;
    margin: 0 auto !important;
    height: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue